import { createSelector } from '@ngrx/store';
import { layoutFeature } from './layout.reducer';

// Base selectors
export const selectLayoutState = layoutFeature.selectLayoutState;

export const selectIsMobile = layoutFeature.selectIsMobile;
export const selectIsSidebarOpened = layoutFeature.selectIsSidebarOpened;
export const selectIsRightPanelOpened = layoutFeature.selectIsRightPanelOpened;
export const selectIsRightPanelMaximized = layoutFeature.selectIsRightPanelMaximized;

// Computed selectors
export const selectRightPanelWidth = createSelector(selectIsRightPanelOpened, selectIsRightPanelMaximized, (isOpened, isMaximized) => {
  if (!isOpened) return 0;
  return isMaximized ? '100%' : '400px';
});
